<mat-form-field>
  <mat-label>Inkomst per månad före skatt</mat-label>
  <input #input="ngModel" [(ngModel)]="model" inputmode="numeric"
         matInput
         maxlength="13"
         [minLength]="2"
         min="10"
         placeholder="Inkomst per månad före skatt" required spbFormatNumber>
  <span matTextSuffix>kr</span>

  @if (input.errors) {
    <mat-error>Vänligen kontrollera fältet</mat-error>
  }

  @if (input.errors && input.touched) {
    <mat-icon matIconSuffix aria-hidden="true">
      priority_high
    </mat-icon>
  }
</mat-form-field>
